const mask = {
  m3: 3,
  hL: 4,
  L: 3,
  dL: 2,
  cL: 1,
  mL: 0,
  barrelUS: 3,
  barrelUK: 3,
  flozUK: 2,
  flozUS: 2,
  galUK: 3,
  galUS: 3,
  giUK: 3,
  giUS: 3,
  pintUK: 3,
  pintUS: 3,
  qtUK: 3,
  qtUS: 3,
  celsius: 2,
  fahrenheit: 2,
  TAV: 2,
  'g / L': 2,
  'mg / L': 0,
};

module.exports = mask;
